Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findRouteComponent;

var _exposeMetrics = require("./exposeMetrics");

function findRouteComponent() {
  var routes = (0, _exposeMetrics.getMountedInstances)();
  var component = routes && routes.length > 0 && routes[routes.length - 1];
  return component;
}